export class DeviceParamInclinoV2 {
    public trigger: number;
}
